// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-lg {
    max-width: 900px !important;
}
a {
    cursor: pointer;
}
.not-pass-qualification {
    color: #dc3545;
}
.pass-qualification {
    color: #28a745;
}

.position-add-muted-alert, .healt-locate-muted-alert, .position-add-date-muted-alert {
    visibility: hidden;
    font-size: 15px !important;
    font-weight: bold;
}

.healt-locate-muted-alert.show, .position-add-muted-alert.show, .position-add-date-muted-alert.show   {
    visibility: visible;
    color: #dc3545;
}

.airforce-id {
    font-size: 12px;
    font-weight: 300;
}`, "",{"version":3,"sources":["webpack://./src/components/StudentChangeTermModal/StudentChangeTermModal.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;AAC/B;AACA;IACI,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".modal-lg {\n    max-width: 900px !important;\n}\na {\n    cursor: pointer;\n}\n.not-pass-qualification {\n    color: #dc3545;\n}\n.pass-qualification {\n    color: #28a745;\n}\n\n.position-add-muted-alert, .healt-locate-muted-alert, .position-add-date-muted-alert {\n    visibility: hidden;\n    font-size: 15px !important;\n    font-weight: bold;\n}\n\n.healt-locate-muted-alert.show, .position-add-muted-alert.show, .position-add-date-muted-alert.show   {\n    visibility: visible;\n    color: #dc3545;\n}\n\n.airforce-id {\n    font-size: 12px;\n    font-weight: 300;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
